module.exports = __webpack_public_path__ + "static/media/pulseplay.ddf08892.png";